"use client";

import NextScript from "next/script";
import React from "react";
import { useConsent, useIsPay } from "../Consent/hooks";

export const MSClarity: React.FC = () => {
    const consent = useConsent();
    const isPay = useIsPay();
    // eslint-disable-next-line react-hooks/purity
    const shouldRender = Math.random() < 0.2; // only every 5th user should have clarity enabled

    if (!consent || isPay || !shouldRender) {
        return null;
    }

    return (
        <NextScript id="msclarity" strategy="lazyOnload">
            {`
                (function(c,l,a,r,i,t,y){
                    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                })(window, document, "clarity", "script", "vneibwgocn");
            `}
        </NextScript>
    );
};
